import axios from 'axios';

const API_URL = 'https://nathnagribareilly.com/api/index.php?action=getTemples';

// ----------------- SETTINGS ----------------
export const getSettings = async () => {
  try {
    const response = await axios.get('https://nathnagribareilly.com/api/index.php?action=getSettings', { timeout: 5000 });
    return response.data;
  } catch (error) {
    console.error("Fetch settings error", error);
    return {
      showAboutUs: true,
      showNathTemples: true,
      showOtherTemples: true,
      showBlogs: true,
      showAdAbout: true,
      homepageAdsConfig: {
        hero: { enabled: false, type: "image", content: "", link: "" },
        about: { enabled: false, type: "image", content: "", link: "" },
        nathTemples: { enabled: false, type: "image", content: "", link: "" },
        otherTemples: { enabled: false, type: "image", content: "", link: "" },
        blogs: { enabled: false, type: "image", content: "", link: "" }
      }
    };
  }
};

export const updateSettings = async (newSettings) => {
  try {
    const response = await axios.post('https://nathnagribareilly.com/api/index.php?action=updateSettings', newSettings);
    return response.data;
  } catch (error) {
    console.error("Update settings error", error);
    return { success: false };
  }
};

// ----------------- TEMPLES -----------------
let dummyTemples = [
  { id: 1, slug: "alakhnath-temple", name: "अलखनाथ मंदिर (Alakhnath Temple)", description: "दशनामी संन्यासियों के आनंद अखाड़े का मुख्यालय। भक्त यहां प्रार्थना करते हैं और जानवरों को भोजन कराते हैं।", full_description: "अलखनाथ मंदिर दशनामी संन्यासियों के आनंद अखाड़ा आदेश का मुख्यालय है। यह बरेली के प्रमुख शिव मंदिरों में से एक है। इस परिसर में कई छोटे मंदिर और भगवान शिव की विशाल प्रतिमाएं स्थित हैं।", location: "किला रोड, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1599839619722-39751411ea63?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3619, lng: 79.4217, rating: 4.8, reviews: 124, faqs: [{ question: "Is photography allowed inside?", answer: "Photography is restricted inside the primary sanctum sanctorum but allowed in the outer corridors.", status: "active" }, { question: "Are there any special aartis?", answer: "Yes, special evening aartis are conducted daily at <b>7 PM</b>.", status: "active" }] },
  { id: 2, slug: "trivati-nath-temple", name: "त्रिवटी नाथ मंदिर (Trivati Nath Temple)", description: "शहर के मध्य में स्थित यह सुंदर मंदिर भगवान शिव को समर्पित है और अपने शांत वातावरण के लिए प्रसिद्ध है।", full_description: "त्रिवटी नाथ मंदिर बरेली के प्राचीन नाथ मंदिरों में से एक है। यह शहर के मध्य भाग में स्थित है। पौराणिक कथाओं के अनुसार भगवान शिव ने यहां एक चरवाहे को दर्शन दिए थे।", location: "मैकनेयर रोड, बरेली", morning_timing: "सुबह 4:30 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 10:00", image: "https://images.unsplash.com/photo-1604580864964-0462f5d5b1a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3725, lng: 79.4320, rating: 4.6, reviews: 312 },
  { id: 3, slug: "madhinath-temple", name: "मढ़ीनाथ मंदिर (Madhinath Temple)", description: "भगवान शिव को समर्पित एक प्राचीन मंदिर, जिसका इतिहास बरेली शहर की स्थापना से जुड़ा है।", full_description: "मढ़ीनाथ मंदिर भगवान शिव को समर्पित है और उन सात ऐतिहासिक नाथ मंदिरों में से एक है जिनके कारण बरेली को 'नाथ नगरी' कहा जाता है। इसका इतिहास पौराणिक गाथाओं से जुड़ा है।", location: "मढ़ीनाथ, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1514222049077-df903dce311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3450, lng: 79.4120, rating: 4.5, reviews: 189 },
  { id: 4, slug: "dhopeshwarnath-temple", name: "धोपेश्वरनाथ मंदिर (Dhopeshwarnath Temple)", description: "यह भव्य मंदिर अपने विशाल पवित्र कुंड और ऐतिहासिक महत्व के लिए प्रसिद्ध है।", full_description: "धोपेश्वरनाथ मंदिर भगवान शिव को समर्पित है। यह मंदिर परिसर के समीप स्थित विशाल जल निकाय (कुंड) के लिए भी विशेष रूप से जाना जाता है जहां भक्त पवित्र स्नान करते हैं।", location: "कैंटोनमेंट, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 8:30", image: "https://images.unsplash.com/photo-1621217637843-c052822aefad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3401, lng: 79.4452, rating: 4.7, reviews: 215 },
  { id: 5, slug: "bankhandinath-temple", name: "बनखंडीनाथ मंदिर (Bankhandinath Temple)", description: "शहर की भीड़भाड़ से थोड़ा दूर हरियाली के बीच स्थित एक शांत और ध्यान योग के लिए उपयुक्त मंदिर।", full_description: "बनखंडीनाथ मंदिर प्राकृतिक हरियाली के बीच स्थित है और प्रार्थना और ध्यान के लिए एक अद्भुत शांत वातावरण प्रदान करता है।", location: "सुभाष नगर, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 8:00", image: "https://images.unsplash.com/photo-1596484552803-0c46b97607a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3305, lng: 79.4201, rating: 4.4, reviews: 156 },
  { id: 6, slug: "tapeshwarnath-temple", name: "तपेश्वरनाथ मंदिर (Tapeshwarnath Temple)", description: "पुरानी पारंपरिक शैली का नाथ मंदिर, जो अपनी दैनिक आरती और भव्य वास्तुकला के लिए प्रसिद्ध है।", full_description: "तपेश्वरनाथ मंदिर अपनी पारंपरिक वास्तुकला और जीवंत दैनिक आरती से भक्तों को आकर्षित करता है। स्थानीय लोग बड़ी संख्या में यहां दर्शन के लिए आते हैं।", location: "सुभाष नगर (पुराना शहर), बरेली", morning_timing: "सुबह 5:30 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3380, lng: 79.4050, rating: 4.6, reviews: 198 },
  { id: 7, slug: "pashupatinath-temple", name: "पशुपतिनाथ मंदिर (Pashupatinath Temple)", description: "भगवान शिव के पशुपतिनाथ स्वरूप को समर्पित एक नवनिर्मित और भव्य नाथ मंदिर।", full_description: "भगवान शिव के पशुपतिनाथ रूप की भव्यता को दर्शाने के लिए बनाया गया यह मंदिर, नाथ मंदिरों की श्रृंखला में एक नया और महत्वपूर्ण आध्यात्मिक केंद्र है।", location: "पीलीभीत बायपास रोड, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3840, lng: 79.4820, rating: 4.9, reviews: 420 },
  { id: 8, slug: "pashupatinath-temple-2", name: "पशुपतिनाथ मंदिर (Pashupatinath Temple)", description: "भगवान शिव के पशुपतिनाथ स्वरूप को समर्पित एक नवनिर्मित और भव्य नाथ मंदिर।", full_description: "भगवान शिव के पशुपतिनाथ रूप की भव्यता को दर्शाने के लिए बनाया गया यह मंदिर, नाथ मंदिरों की श्रृंखला में एक नया और महत्वपूर्ण आध्यात्मिक केंद्र है।", location: "पीलीभीत बायपास रोड, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3840, lng: 79.4820, rating: 4.9, reviews: 420 }
];

// ----------------- BLOGS -----------------
let dummyBlogs = [
  { id: 1, title: "नाथ नगरी का इतिहास: सात शिव मंदिरों की कहानी", excerpt: "बरेली को नाथ नगरी क्यों कहा जाता है? आइए जानते हैं इन प्राचीन शिव मंदिरों के पीछे की पौराणिक कथाएं और इतिहास।", content: "<p>बरेली को 'नाथ नगरी' के रूप में जाना जाता है क्योंकि इस शहर के चारों कोनों और मध्य में भगवान शिव के सात प्राचीन मंदिर स्थित हैं। इन मंदिरों का निर्माण और महत्व अत्यंत प्राचीन है। त्रिवटी नाथ, अलखनाथ, मढ़ीनाथ, धोपेश्वरनाथ, बनखंडीनाथ, तपेश्वरनाथ, और पशुपतिनाथ - ये सातों मंदिर बरेली की आध्यात्मिक पहचान हैं। हर शिवरात्रि और सावन के महीने में यहां लाखों भक्तों की भीड़ उमरती है।...</p>", date: "12 मार्च 2026", author: "Admin", image: "https://images.unsplash.com/photo-1552554625-ecc199e46a9a", status: "published", rating: 4.5, ratingCount: 12 },
  { id: 2, title: "सावन मास की तैयारियां: कांवड़ यात्रा और शिव पूजा", excerpt: "इस सावन मास में भगवान शिव की आराधना का विशेष महत्व है। जानें कि इस बार कांवड़ यात्रा के लिए क्या-क्या खास तैयारियां की गई हैं।", content: "<p>सावन के महीने में बरेली के नाथ मंदिरों की रौनक देखते ही बनती है। दूर-दूर से कांवड़िये गंगा जल लेकर भगवान शिव का अभिषेक करने आते हैं। इस साल प्रशासन ने सभी मंदिरों के आस-पास विशेष सुरक्षा और भक्तों के लिए जलपान की व्यवस्था की है। सावन के हर सोमवार को विशेष रुद्राभिषेक का भी आयोजन होगा।</p>", date: "24 जुलाई 2026", author: "Raman", image: "https://images.unsplash.com/photo-1623062635900-514be0f09852", status: "published", rating: 5, ratingCount: 8 },
  { id: 3, title: "महाशिवरात्रि मेला - 2026 (Pending Approval)", excerpt: "आगामी शिवरात्रि मेले के लिए प्रशासन की नई व्यवस्था।", content: "<p>यह एक उपयोगकर्ता द्वारा सबमिट किया गया ब्लॉग है जिसे स्वीकृति की प्रतीक्षा है।</p>", date: "28 मार्च 2026", author: "Devotee User", image: "https://images.unsplash.com/photo-1514222049077-df903dce311a", status: "pending", rating: 0, ratingCount: 0 }
];

// ----------------- COMMENTS -----------------
let dummyComments = [
  { id: 101, blogId: 1, text: "बहुत ही ज्ञानवर्धक लेख!", author: "Vikas M.", date: "13 मार्च 2026" },
  { id: 102, blogId: 1, text: "मुझे त्रिवटी नाथ मंदिर की आरती का समय क्या मिलेगा?", author: "Priya S.", date: "14 मार्च 2026" },
];

// ----------------- ADS -----------------
let dummyAds = [
  { id: 1, title: "Spiritual Book Store", link: "https://example.com", image: "https://via.placeholder.com/300x250?text=Ad:+Gita+Store", placement: "sidebar", status: "active" },
  { id: 2, title: "Bareilly Tours", link: "https://example.com", image: "https://via.placeholder.com/728x90?text=Ad:+City+Tours", placement: "banner", status: "active" },
];

// ----------------- ABOUT PAGE DATA -----------------
let dummyAboutPageData = {
  pageTitle: "हमारे बारे में (About Us)",
  metaTitle: "हमारे बारे में (About Us) | Nath Nagri Bareilly",
  metaDescription: "नाथ नगरी बरेली के सात प्राचीन शिव मंदिरों के बारे में जानें। Discover the history of Nathnagri Temples.",
  heroHeading: "हमारे बारे में (About Us)",
  heroSubheading: "नाथ नगरी की प्राचीन और आध्यात्मिक विरासत का अन्वेषण करें।",
  heroImage: "",
  mainContent: "<h3>नाथ मंदिरों का महत्व</h3><p>इन सात मंदिरों—अलखनाथ, त्रिवटी नाथ, मढ़ीनाथ, धोपेश्वरनाथ, बनखंडीनाथ, तपेश्वरनाथ, और पशुपतिनाथ—के कारण ही इस क्षेत्र में एक विशेष प्रकार की ऊर्जा और शांति का अनुभव होता है। प्रत्येक मंदिर का अपना ऐतिहासिक और पौराणिक महत्व है।</p><h3><strong>बरेली का इतिहास</strong></h3><p>बरेली, उत्तर प्रदेश के प्रमुख और ऐतिहासिक शहरों में से एक है, जो पश्चिमी उत्तर प्रदेश के महत्वपूर्ण केंद्र के रूप में जाना जाता है।</p>",
  missionTitle: "हमारा उद्देश्य",
  missionDesc: "<p>नाथ नगरी बरेली वेबसाइट का उद्देश्य इन पवित्र सिद्धपीठों के बारे में विस्तृत जानकारी प्रदान करना है ताकि यहाँ आने वाले श्रद्धालु और अन्य लोग इसके इतिहास, आरती व दर्शन के समय, और धार्मिक आयोजनों से अवगत रह सकें।</p>",
  visionTitle: "",
  visionDesc: "",
  optionalSections: [],
  teamMembers: [],
  ctaText: "क्या आप हमारे इस प्रयास से जुड़ना चाहते हैं?",
  ctaBtnLabel: "संपर्क करें",
  ctaBtnLink: "/contact-us"
};

export const getAboutPageData = async () => {
  try {
    const response = await axios.get(`https://nathnagribareilly.com/api/index.php?action=getAboutData`, { timeout: 5000 });
    if (response.data && response.data.pageTitle) return response.data;
    return dummyAboutPageData;
  } catch {
    return dummyAboutPageData;
  }
};

export const updateAboutPageData = async (data) => {
  try {
    const response = await axios.post(`https://nathnagribareilly.com/api/index.php?action=updateAboutData`, data);
    dummyAboutPageData = { ...dummyAboutPageData, ...data };
    return { success: response.data?.status === 'success' || true };
  } catch {
    dummyAboutPageData = { ...dummyAboutPageData, ...data };
    return { success: true };
  }
};

export const getTemples = async () => {
  try {
    const response = await axios.get(API_URL, { timeout: 5000 });
    if (Array.isArray(response.data) && response.data.length === 0) return dummyTemples;
    const data = response.data.map(t => {
      const match = dummyTemples.find(d => d.id === t.id);
      
      // Merge slug from backend, then memory cache, then dynamically generate
      let generatedSlug = t.slug || (match ? match.slug : '');
      if (!generatedSlug && t.name) {
         // Create slug from english text inside parenthesis if possible, else the main name
         const enMatch = t.name.match(/\((.*?)\)/);
         const baseName = enMatch ? enMatch[1] : t.name;
         generatedSlug = baseName.toLowerCase().replace(/[\s_]+/g, '-').replace(/[^\w-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
         if(!generatedSlug) generatedSlug = t.id.toString();
      }

      return { 
        ...t, 
        slug: generatedSlug,
        rating: t.rating || (match ? match.rating : 4.5), 
        reviews: t.reviews || (match ? match.reviews : 100) 
      };
    });
    return data;
  } catch {
    return dummyTemples;
  }
};

export const getTempleById = async (id) => {
  const [temples, otherTemples] = await Promise.all([getTemples(), getOtherTemples()]);
  const allTemples = [...temples, ...otherTemples];
  return allTemples.find(t => t.id.toString() === id.toString() || (t.slug && t.slug === id.toString())) || null;
};

export const getRelatedTemples = async (currentId, limit = 4) => {
  const [temples, otherTemples] = await Promise.all([getTemples(), getOtherTemples()]);
  let allTemples = [...temples, ...otherTemples];
  
  // Filter out the current temple
  allTemples = allTemples.filter(t => t.id.toString() !== currentId.toString() && t.slug !== currentId.toString());
  
  // Recommendation fallback: since they are all in Bareilly, we prioritize highly-rated ones.
  // In a full implementation, you would sort by t.category or t.tags matching the current temple.
  allTemples.sort((a, b) => (b.rating || 0) - (a.rating || 0));
  
  // Shuffle slightly for variance if ratings match
  allTemples.sort((a, b) => {
    if (a.rating === b.rating) return 0.5 - Math.random();
    return 0;
  });
  
  return allTemples.slice(0, limit);
};

export const submitTempleRating = async (templeId, rating) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'rateTemple')}`, { id: templeId, rating });
    if(response.data && response.data.status === 'success') {
       return { success: true, message: 'Rating saved' };
    }
  } catch (error) {
    console.error("Submit rating error:", error);
  }

  // Local fallback
  return new Promise(resolve => {
    dummyTemples = dummyTemples.map(t => {
      if (t.id === templeId) {
        const currentReviews = Number(t.reviews) || 0;
        const currentRating = Number(t.rating) || 0;
        const newReviews = currentReviews + 1;
        const newRating = ((currentRating * currentReviews) + rating) / newReviews;
        return { ...t, rating: parseFloat(newRating.toFixed(1)), reviews: newReviews };
      }
      return t;
    });
    setTimeout(() => resolve({ success: true, message: 'Rating saved locally' }), 800);
  });
};

export const addTemple = async (templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'addTemple')}`, templeData);
    if(response.data.status === 'success') {
       // Also push to local array so UI updates instantly without refetching if preferable, but let's just return true.
       const newTemple = { id: response.data.id || Date.now(), rating: 0, reviews: 0, ...templeData };
       dummyTemples.push(newTemple);
       return { success: true, temple: newTemple };
    }
    return { success: false, message: "Failed to add temple" };
  } catch (error) {
    console.error("Add temple error", error);
    return { success: false, message: "Network error" };
  }
};

export const updateTemple = async (id, templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'updateTemple')}`, { id, ...templeData });
    if(response.data.status === 'updated') {
       dummyTemples = dummyTemples.map(t => t.id === id ? { ...t, ...templeData } : t);
       return { success: true };
    }
    return { success: false, message: "Failed to update temple" };
  } catch (error) {
    console.error("Update temple error", error);
    return { success: false, message: "Network error" };
  }
};

export const deleteTemple = async (id) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'deleteTemple')}`, { id });
    if(response.data.status === 'deleted') {
       dummyTemples = dummyTemples.filter(t => t.id !== id);
       return { success: true };
    }
    return { success: false, message: "Failed to delete temple" };
  } catch (error) {
    console.error("Delete temple error", error);
    return { success: false, message: "Network error" };
  }
};

// ----------------- OTHER TEMPLES -----------------
export const getOtherTemples = async () => {
  try {
    const response = await axios.get(`${API_URL.replace('getTemples', 'getOtherTemples')}`, { timeout: 5000 });
    if (Array.isArray(response.data)) {
       return response.data.map(t => {
         let generatedSlug = t.slug;
         if (!generatedSlug && t.name) {
           const enMatch = t.name.match(/\((.*?)\)/);
           const baseName = enMatch ? enMatch[1] : t.name;
           generatedSlug = baseName.toLowerCase().replace(/[\s_]+/g, '-').replace(/[^\w-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
           if(!generatedSlug) generatedSlug = t.id.toString();
         }
         return {
           ...t,
           slug: generatedSlug,
           rating: t.rating || 4.5,
           reviews: t.reviews || 0
         };
       });
    }
    return [];
  } catch {
    return [];
  }
};

export const getOtherTempleById = async (id) => {
  const temples = await getOtherTemples();
  return temples.find(t => t.id.toString() === id.toString() || (t.slug && t.slug === id.toString())) || null;
};

export const addOtherTemple = async (templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'addOtherTemple')}`, templeData);
    if(response.data.status === 'success') {
       return { success: true, id: response.data.id };
    }
    return { success: false, message: "Failed to add temple" };
  } catch (error) {
    return { success: false, message: "Network error" };
  }
};

export const updateOtherTemple = async (id, templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'updateOtherTemple')}`, { id, ...templeData });
    if(response.data.status === 'updated') {
       return { success: true };
    }
    return { success: false, message: "Failed to update temple" };
  } catch (error) {
    return { success: false, message: "Network error" };
  }
};

export const deleteOtherTemple = async (id) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'deleteOtherTemple')}`, { id });
    if(response.data.status === 'deleted') {
       return { success: true };
    }
    return { success: false, message: "Failed to delete temple" };
  } catch (error) {
    return { success: false, message: "Network error" };
  }
};

export const uploadFileToServer = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    
    const response = await axios.post(`${API_URL.replace('getTemples', 'uploadImage')}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    if (response.data.success) {
      return { success: true, url: response.data.url };
    }
    return { success: false, message: response.data.message || "Failed to upload" };
  } catch (error) {
    console.error("Upload error", error);
    return { success: false, message: "Upload failed: Network error" };
  }
};

// ----------------- USERS -----------------
let dummyUsers = [
  { id: 1, name: 'Main Admin', email: 'admin@nathnagri.com', password: 'admin123', role: 'admin' },
  { id: 2, name: 'Content Editor', email: 'editor@nathnagri.com', password: 'editor123', role: 'editor' },
  { id: 3, name: 'Devotee User', email: 'user@test.com', password: 'user123', role: 'user' }
];

/* --- Auth & Users API --- */
const BASE_API_URL = 'https://nathnagribareilly.com/api/index.php';

export const authenticateUser = async (email, password) => {
  try {
    // Attempt to login using the actual PHP backend
    const response = await axios.post(`${BASE_API_URL}?action=login`, { email, password });

    // Safely parse potentially broken PHP output (like empty strings or HTML warnings)
    if (typeof response.data !== 'object' || response.data === null) {
      console.error("PHP Returned Invalid Data:", response.data);
      return { success: false, message: 'Server did not return valid JSON. There is likely an error in the PHP file.' };
    }

    return response.data;
  } catch (error) {
    console.error("Login Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const getUsers = async () => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getUsers`);
    return Array.isArray(response.data) ? response.data : dummyUsers;
  } catch (error) {
    return dummyUsers;
  }
};

export const signupUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=signup`, userData);
    return response.data;
  } catch (error) {
    console.error("Signup User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=createUser`, userData);
    return response.data;
  } catch (error) {
    console.error("Create User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=deleteUser`, { id });
    return response.data;
  } catch (error) {
    console.error("Delete User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const updateUserRole = async (id, newRole) => {
  // Fallback to dummy behavior currently since there is no update PHP block provided yet
  return new Promise(resolve => {
    dummyUsers = dummyUsers.map(u => u.id === id ? { ...u, role: newRole } : u);
    setTimeout(() => resolve({ success: true }), 300);
  });
};

let _cachedBlogs = null;
let _cachedBlogsTime = 0;

export const getBlogs = async (status = "published") => {
  try {
    // 🛡️ STOP React-Snap from fetching blogs! 
    if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') {
      return [];
    }

    let rawBlogs = [];
    const now = Date.now();
    if (_cachedBlogs && now - _cachedBlogsTime < 30000) {
      rawBlogs = _cachedBlogs;
    } else {
      const res = await axios.get(`${BASE_API_URL}?action=getBlogs`, { timeout: 5000 });
      rawBlogs = Array.isArray(res.data) ? res.data : [];
      _cachedBlogs = rawBlogs;
      _cachedBlogsTime = now;
    }

    let blogs = rawBlogs;
    if (status !== "all") {
      blogs = blogs.filter(b => b.status === status);
    }
    
    // Compute the correct date based on updated_at/created_at or legacy date
    blogs = blogs.map(b => {
      let finalDate = 'Today';
      const ts = b.updated_at || b.created_at;
      
      if (ts && ts !== '0000-00-00 00:00:00') {
        const d = new Date(ts.replace(/-/g, '/')); // Safari compat
        if (!isNaN(d.getTime())) {
          const day = d.getDate().toString().padStart(2, '0');
          const month = d.toLocaleString('en-US', { month: 'short' });
          const year = d.getFullYear();
          finalDate = `${day} ${month} ${year}`;
        }
      } else if (b.date) {
        finalDate = b.date; // Use existing text representation
      }

      return {
        ...b,
        date: finalDate,
        slug: b.slug || (b.title ? encodeURIComponent(b.title.trim().replace(/\s+/g, '-').replace(/[/\\?%*:|"<>]/g, '')) : b.id.toString())
      };
    });
    
    return blogs.length ? blogs : dummyBlogs.map(b => ({...b, slug: b.title ? encodeURIComponent(b.title.trim().replace(/\s+/g, '-').replace(/[/\\?%*:|"<>]/g, '')) : b.id.toString()})).filter(b => status === 'all' || b.status === status);
  } catch(e) {
    return dummyBlogs.map(b => ({...b, slug: b.title ? encodeURIComponent(b.title.trim().replace(/\s+/g, '-').replace(/[/\\?%*:|"<>]/g, '')) : b.id.toString()})).filter(b => status === 'all' || b.status === status);
  }
};

export const getBlogById = async (id) => {
  const blogs = await getBlogs("all");
  return blogs.find(b => 
    b.id.toString() === id.toString() || 
    b.slug === id.toString() || 
    b.slug === encodeURIComponent(id.toString()) || 
    decodeURIComponent(b.slug) === id.toString()
  ) || null;
};

export const getRelatedBlogs = async (currentId, limit = 4) => {
  const blogs = await getBlogs("published");
  
  // Exclude current blog
  let related = blogs.filter(b => 
    b.id.toString() !== currentId.toString() && 
    b.slug !== currentId.toString() &&
    decodeURIComponent(b.slug) !== currentId.toString()
  );
  
  // Simulate recommendation by matching category/tags or falling back to newest/highest rated
  related.sort((a, b) => {
     // fallback sort by rating
     if (b.rating !== a.rating) return (b.rating || 0) - (a.rating || 0);
     // further fallback by random
     return 0.5 - Math.random();
  });
  
  return related.slice(0, limit);
};

export const submitBlog = async (blogData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=addBlog`, blogData);
    if(response.data.success) {
      return { success: true, blog: { ...blogData, id: Date.now() } };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export const editBlogServer = async (blogData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=editBlog`, blogData);
    if(response.data.success) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export const updateBlogStatus = async (blogId, status) => {
  try {
    await axios.get(`${BASE_API_URL}?action=updateBlogStatus&id=${blogId}&status=${status}`);
    return { success: true };
  } catch(e) {
    return { success: false };
  }
};

export const rateBlog = async (blogId, ratingVal) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=rateBlog`, { id: blogId, rating: ratingVal });
    return { success: response.data?.success };
  } catch (error) {
    return { success: false };
  }
};

/* --- Comments API --- */
export const getCommentsForBlog = async (blogId) => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getBlogComments&blog_id=${blogId}`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    return [];
  }
};

export const addComment = async (blogId, text, author) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=addBlogComment`, { blog_id: blogId, comment: text, user_name: author });
    if (response.data.success) {
       return { success: true, comment: response.data.comment };
    }
  } catch (error) {}
  return { success: false };
};

/* --- Ads API --- */
export const getAds = async () => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getAds`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    return dummyAds;
  }
};

export const getAdByPlacement = async (placement, pageName = 'global') => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getAds&placement=${placement}&page_name=${pageName}`);
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }
    return null;
  } catch (error) {
    return dummyAds.find(ad => ad.placement === placement && ad.status === 'active') || null;
  }
};

export const saveAd = async (adData) => {
  try {
    const action = adData.id ? 'updateAd' : 'addAd';
    const response = await axios.post(`${BASE_API_URL}?action=${action}`, adData);
    return { success: response.data.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const toggleAdStatus = async (adData) => {
  try {
    const newStatus = adData.status === 'active' ? 'inactive' : 'active';
    const response = await axios.post(`${BASE_API_URL}?action=updateAd`, { ...adData, status: newStatus });
    return { success: response.data.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const deleteAd = async (id) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=deleteAd`, { id });
    return { success: response.data.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

/* --- Polls API --- */
export const getAdminPolls = async () => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getAdminPolls`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    return [];
  }
};

export const getActivePolls = async () => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getActivePolls`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    return [];
  }
};

export const addAdminPoll = async (pollData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=addAdminPoll`, pollData);
    return { success: response.data?.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const updateAdminPoll = async (pollData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=editAdminPoll`, pollData);
    return { success: response.data?.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const deleteAdminPoll = async (id) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=deleteAdminPoll`, { id });
    return { success: response.data?.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const togglePollStatus = async (pollData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=toggleAdminPollStatus`, pollData);
    return { success: response.data?.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

export const submitVote = async (optionId) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=voteAdminPoll`, { option_id: optionId });
    return { success: response.data?.status === 'success' };
  } catch (error) {
    return { success: false };
  }
};

/* --- General Website API --- */
export const submitContactForm = async (contactData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=contactUs`, contactData);
    return response.data;
  } catch (error) {
    console.error("Contact Form Axios Error:", error);
    return { success: false, message: "Network error occurred." };
  }
};